export const getData = Bonuses => {
  if ([undefined, null, ""].includes(Bonuses)) return []
  let data = []
  for (const bonus of Bonuses) {
    data.push({
      id: bonus.id,
      start_date: bonus?.start_date,
      end_date: bonus?.end_date,
      type: bonus?.type,
      value: bonus?.value,
      max_bonus: bonus?.max_bonus,
      bonus_type: bonus?.bonus_type?.name,
    })
  }
  return data
}
